<template>
  <section
    ref="spotlist"
    class="spotlist"
  >
    <SectionTitle
      :title="title"
    />
    <ul class="block">
      <li
        v-for="item in contents.slice(0, isDisplayMore ? contents.length : MAX_NUM)"
        :key="item.text"
        class="list"
      >
        <NuxtLink
          :to="isExternalLink ? `${runtimeConfig.app.baseURL}${item.href.replace(/^\//, '')}` : item.href"
          :external="isExternalLink"
          class="link"
        >
          {{ item.text }}
        </NuxtLink>
      </li>
      <button
        v-if="contents.length > MAX_NUM"
        class="more"
        :class="{ isOpen: isDisplayMore }"
        @click="clickShowMore"
      >
        <span class="text">
          {{ isDisplayMore ? '少なく表示する' : 'もっと見る' }}
        </span>
        <span
          class="icon"
        />
      </button>
    </ul>
  </section>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true
  },
  contents: {
    type: Array,
    required: true
  }
})
const MAX_NUM = 10
const isDisplayMore = ref(false)

const spotlistRef = useTemplateRef('spotlist')

const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const isExternalLink = ref(isWebViewFlag)

const getViewerType = () => {
  return window?.innerWidth ? window.innerWidth < 830 ? 'sp' : 'pc' : isWebViewFlag ? 'sp' : 'pc'
}
const sleep = (msec) => new Promise((resolve) => setTimeout(resolve, msec))

const clickShowMore = () => {
  isDisplayMore.value = !isDisplayMore.value
  if (!isDisplayMore.value) {
    // グローバルヘッダーの中のコンテンツのpadding分ズレることへの対処
    // アプリではないスマホビューの場合はブラウザ分もズレるので、決め打ちでさらに対処
    const globalHeaderContentPadding = isWebViewFlag ? 15 : getViewerType() === 'pc' ? 120 : 20 + 10
    sleep(100).then(() => {
      window.scrollTo({
        top: spotlistRef.value.offsetTop - globalHeaderContentPadding,
        behavior: 'smooth'
      })
    })
  }
}
</script>

<style lang="scss" scoped>
.spotlist {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .block {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px;
    border-radius: 6px;
    background-color: #eef1f8;

    .more {
      display: flex;
      align-items: center;
      gap: 2px;
      cursor: pointer;
      .text {
        display: block;
        color: #3569C0;
        font-size: 15px;
        font-weight: 600;
        line-height: 1em;
        text-decoration: underline;
      }
      .icon {
        position: relative;
        display: block;
        width: 14px;
        height: 14px;
        background-color: #3569C0;
        clip-path: polygon(0 0, 100% 0, 50% 100%);
      }
      &.isOpen .icon {
        clip-path: polygon(50% 0, 100% 100%, 0 100%);
      }
    }
    @media (any-hover: hover) {
      .more {
        transition: opacity .2s ease-in-out;
        &:hover {
          opacity: .6;
        }
      }
    }
  }

  .link {
    display: flex;
    padding: 6px 10px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / .15);
    color: #3569C0;
    font-size: 14px;
    font-weight: 300;
    line-height: 15px;
    text-decoration: underline;
  }

  @media screen and (min-width: 830px) {
    .link {
      transition: box-shadow .2s ease-in-out;

      &:hover {
        box-shadow: 0 2px 6px 0 rgba(#000, .45);
      }
    }
  }
}
</style>
